// extracted by mini-css-extract-plugin
var _1 = "_dailySilverPrice-module__block-container";
var _2 = "_dailySilverPrice-module__buy-price";
var _3 = "_dailySilverPrice-module__container";
var _4 = "_dailySilverPrice-module__info-container";
var _5 = "_dailySilverPrice-module__price";
var _6 = "_dailySilverPrice-module__price-container";
var _7 = "_dailySilverPrice-module__price-label";
var _8 = "_dailySilverPrice-module__sell-price";
var _9 = "_dailySilverPrice-module__silver-price-text";
var _a = "_dailySilverPrice-module__title";
export { _1 as "block-container", _2 as "buy-price", _3 as "container", _4 as "info-container", _5 as "price", _6 as "price-container", _7 as "price-label", _8 as "sell-price", _9 as "silver-price-text", _a as "title" }
